import { useState } from "react";
import { useSelector } from "react-redux";
import { Button, Form } from "react-bootstrap";
import axios from "axios";

const QuoteAssignmentComponent = ({ quoteId, assignedTo, onAssigned }) => {
  const { userInfo } = useSelector((state) => state.userRegisterLogin);
  const canReassign = Boolean(userInfo?.isSales || userInfo?.isSuperAdmin);
  const [editing, setEditing] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [selected, setSelected] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const name = [assignedTo?.name, assignedTo?.lastName].filter(Boolean).join(" ");

  const edit = async () => {
    if (!canReassign) return;
    setEditing(true);
    setError("");
    setBusy(true);
    setEmployees([]);
    setSelected(assignedTo?._id || "");
    try {
      const { data } = await axios.get("/api/quotes/admin/assignees");
      setEmployees([...data].sort((a, b) =>
        Number(String(b._id) === String(userInfo?._id)) - Number(String(a._id) === String(userInfo?._id))
      ));
    } catch (err) {
      setError("Failed to load employees. Close and try again.");
    } finally { setBusy(false); }
  };

  const save = async () => {
    if (!canReassign) return;
    setBusy(true);
    setError("");
    try {
      const { data } = await axios.post("/api/quotes/admin/reassign", { assignedTo: selected }, { params: { quoteId } });
      onAssigned(data.quote.assignedTo);
      setEditing(false);
    } catch (err) {
      setError(err.response?.data?.message || "Failed to reassign quote.");
    } finally { setBusy(false); }
  };

  return (
    <div className="mb-3">
      <div className="d-flex align-items-center gap-2">
        <strong>Assigned To:</strong>
        <span className="badge rounded-pill" style={{ backgroundColor: "#e8eef6", color: "#1e4881" }}>
          {name || "Unassigned"}
        </span>
        {canReassign && <Button type="button" variant="link" className="p-0 d-inline-flex align-items-center justify-content-center" style={{ color: "#1e4881" }} aria-label="Edit quote assignee" title="Reassign quote" disabled={busy || editing} onClick={edit}>
          <i className="bi bi-pencil-square" aria-hidden="true" />
        </Button>}
      </div>
      {canReassign && editing && (
        <div className="mt-2" style={{ maxWidth: "420px" }}>
          <Form.Select aria-label="Assign quote to sales employee" value={selected} disabled={busy} onChange={(event) => setSelected(event.target.value)}>
            <option value="">{busy ? "Loading..." : "Select an employee"}</option>
            {employees.map((employee) => <option key={employee._id} value={employee._id}>
              {[employee.name, employee.lastName].filter(Boolean).join(" ")}{String(employee._id) === String(userInfo?._id) ? " (You)" : ""}
            </option>)}
          </Form.Select>
          <div className="mt-2 d-flex gap-2">
            <Button type="button" size="sm" className="CTL_btn" disabled={busy || !employees.some((employee) => employee._id === selected)} onClick={save}>Save</Button>
            <Button type="button" size="sm" variant="outline-secondary" disabled={busy} onClick={() => { setEditing(false); setError(""); }}>Cancel</Button>
          </div>
          {!busy && !error && employees.length === 0 && <p className="mt-2 mb-0 text-muted">No eligible sales employees found.</p>}
        </div>
      )}
      {error && <div className="text-danger mt-2" role="alert">{error}</div>}
    </div>
  );
};

export default QuoteAssignmentComponent;
